<footer class="c-footer">
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <p class="js-txtf-1"> {{ 'FooterPortal.supportDesk' | translate }}</p>
                <a class="c-footer__contact" href="tel:{{ 'FooterPortal.number' | translate }}" title="{{ 'FooterPortal.contact' | translate }}">
          {{ 'FooterPortal.number' | translate }}
          <i class="icon icon-phone"></i></a>
                <a class="c-footer__link js-txtf-2" [routerLink]="['faq']">{{ 'FooterPortal.faq' | translate }}</a>
            </div>
            <div class="col-md-6"><small> © BHP {{ ano }} </small></div>
        </div>
    </div>
</footer>